<template>
  <div class="scenario">
    <vannav></vannav>
    <dropdown
      ref="ondefvalue"
      :areaList="areaList"
      :defvalue="defvalue"
      @code="code"
    ></dropdown>

    <div v-for="(item, index) in enargyList" :key="item.id" class="ban_text1">
      <div class="middle" @click="todetail(index)">
        <p>采集器</p>
        <p class="">
          <van-tag
            v-if="item.eleOnoff == 1 ? true : false"
            color="rgba(19, 206, 102, .2)"
            text-color="rgba(19, 206, 102, 1)"
            >开闸</van-tag
          >
          <van-tag
            v-else
            color="rgba(255,73,73,0.2)"
            text-color="rgba(255,73,73,1)"
            >关闸</van-tag
          >

          <van-tag
            color="rgba(70, 122, 255, 0.2) "
            text-color="rgba(70, 122, 255, 1) "
            >{{ item.branchCode }}</van-tag
          >
          <van-tag
            color="rgba(70, 122, 255, 0.2) "
            text-color="rgba(70, 122, 255, 1) "
            >{{ item.branchName }}</van-tag
          >
        </p>
        <p class="ptext">
          <span>
            <i> 电流： </i>
            {{ item.lineA }}A</span
          >
          <span> <i> 功率： </i>{{ item.lineP }}W</span>
        </p>
      </div>
      <div>
        <van-switch
          :value="item.eleOnoff == 1 ? true : false"
          active-color="rgba(110, 214, 127, 1)"
          inactive-color="rgba(225, 225, 225, 1)"
          size="20px"
          @input="onInput(index)"
        />
      </div>
    </div>
    <empty :empty="empty"></empty>
  </div>
</template>

<script>
import dropdown from "../common/dropdown.vue";
import vannav from "../components/vannavHone.vue";
import { Dialog, Toast } from "vant";
import { areaBranch, pubMsg } from "@/api/scenario.js";
import { areaTreeCode } from "@/api/energy";

export default {
  components: { vannav, dropdown },
  data() {
    return {
      // img: require("../assets/empty/empty.png"),
      empty: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      },
      // 查询字段
      dateType: "",
      areaId: "",

      date: "",
      // 合计
      topList: {},
      // 数据渲染
      enargyList: [],
      timer: null,
      defvalue: [],
      TreeCode: null,
    };
  },
  beforeMount() {},
  mounted() {
    this.getareaTreeCode();
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    getareaTreeCode() {
      areaTreeCode(this.$token)
        .then((res) => {
          if (res.data.code == 200) {
            this.TreeCode = res.data.data;
            this.areaList.province_list = this.TreeCode.provinceList;
            this.areaList.city_list = this.TreeCode.cityList;
            this.areaList.county_list = this.TreeCode.countryList;
            this.defvalue = [
              {
                code: this.TreeCode.idCode[0].code,
                name: this.areaList.province_list[this.TreeCode.idCode[0].code],
              },
              undefined,

              undefined,
            ];
            this.$refs.ondefvalue.ondefvalue(this.defvalue);
          }
        })
        .catch((err) => {});
    },
    onInput(index) {
      Dialog.confirm({
        title: "提醒",
        message: "是否切换开关？",
      })
        .then(() => {
          console.log(this.enargyList[index]);
          pubMsg(
            this.enargyList[index].collectorSerial,
            this.enargyList[index].branchCode,
            this.enargyList[index].eleOnoff == 1 ? 4 : 1,
            this.enargyList[index].substr,
            this.enargyList[index].branchId
          )
            .then((res) => {
              if (this.enargyList[index].eleOnoff == 1) {
                if (
                  res.data.data.result === "success" &&
                  res.data.data.eleOnoff === "4"
                ) {
                  Toast.success("操作成功");
                  this.enargyList[index].eleOnoff = 0;
                } else {
                  Toast.fail("操作失败");
                }
              } else if (this.enargyList[index].eleOnoff == 0) {
                if (
                  res.data.data.result === "success" &&
                  res.data.data.eleOnoff === "1"
                ) {
                  Toast.success("操作成功");
                  this.enargyList[index].eleOnoff = 1;
                } else {
                  Toast.fail("操作失败");
                }
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    code(e) {
      console.log(e);
      let a = [];
      this.TreeCode.idCode.map((item) => {
        if (e[0] !== undefined) {
          if (item.code == e[0].code) {
            a.push(item.id);
          }
        }

        if (e[1] !== undefined) {
          if (item.code == e[1].code) {
            a.push(item.id);
          }
        }
      });
      this.areaId = a;
      if (this.areaId != null) {
        this.infoareaBranch();
      }
    },
    // 查询设备
    infoareaBranch() {
      areaBranch(this.$token, this.areaId)
        .then((res) => {
          if (res.data.code == 200) {
            if (
              res.data.data.branchList === undefined ||
              res.data.data.branchList.length == 0
            ) {
              this.empty = true;
              this.enargyList = [];
              return;
            }
            this.empty = false;
            this.enargyList = res.data.data.branchList;
            this.enargyList = this.enargyList.map((item) => {
              item.lineA = item.lineA.toFixed(2);
              item.lineP = item.lineP.toFixed(2);
              return item;
            });
            this.$set(this.enargyList);
          }
        })
        .catch((err) => {});
    },
    // 跳转
    todetail(index) {
      this.$router.push({
        path: "/scendetail",
        query: { branchId: this.enargyList[index].branchId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.scenario {
  width: 100%;
  font-style: normal;
  .select {
    width: 100%;
  }

  .ban_text1 {
    margin-top: 10px;
    background-color: #fff;
    box-shadow: 1px 1px 1px #dbdbdb;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 90px;
    padding: 0 10px;

    & > img {
      width: 30px;
      height: 30px;
    }

    .icon-fydyc-copy,
    .icon-fydyc {
      font-size: 30px;
      margin-right: 10px;
    }

    & > .middle {
      text-align: start;
      line-height: 25px;
      color: #6b6b6b;
      cursor: pointer;
      flex: 1;

      & > p {
        &:first-child {
          font: 0.45rem normal;
          font-weight: 600;
        }

        &:nth-child(2) {
          .van-tag {
            margin-right: 0.2rem;
            letter-spacing: 0.03rem;
          }
        }

        &.ptext {
          display: flex;
          justify-content: space-evenly;

          & > span {
            flex: 1;
            font-size: 0.35rem;

            & > i {
              font-style: normal;
              color: rgba(35, 39, 38, 0.4);
            }
          }
        }
      }
    }
  }
}

.van-cell.van-cell--clickable.van-field {
  display: flex;
  justify-content: space-between;

  .van-field__control {
    width: 0.2rem;
  }
}

.van-cell__value.van-field__value {
  width: 1.5rem;
}
</style>
